import { render, staticRenderFns } from "./ContractWithdrawalOtp.vue?vue&type=template&id=1ac08fdb"
import script from "./ContractWithdrawalOtp.vue?vue&type=script&lang=ts"
export * from "./ContractWithdrawalOtp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports